import Loader from "components/loader"
import { IPresence } from "../../types"
import { UseQueryResult } from "@tanstack/react-query"

const Characteristics: React.FC<{
  member: UseQueryResult<IPresence["member"]>
}> = ({ member }) => {
  return (
    <>
      {member.isLoading ? (
        <Loader />
      ) : (
        <div
          className="noStylesReset"
          dangerouslySetInnerHTML={{
            __html: member.data?.characteristics!,
          }}
        />
      )}
    </>
  )
}

export default Characteristics
